import { render, staticRenderFns } from "./vehiclesorn.html?vue&type=template&id=38a70501&scoped=true&external"
import script from "./vehiclesorn.vue?vue&type=script&lang=js"
export * from "./vehiclesorn.vue?vue&type=script&lang=js"
import style0 from "./vehiclesorn.vue?vue&type=style&index=0&id=38a70501&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a70501",
  null
  
)

export default component.exports